import m from 'mithril'

export default {
  view: vnode => {
    return (
      <svg
        className="hotspot-popup-icon mod-video"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          className="hotspot-popup-icon-path"
          d="M23.495 6.205C23.356 5.70676 23.0907 5.25282 22.725 4.88705C22.3592 4.52128 21.9052 4.25605 21.407 4.117C19.537 3.616 12.011 3.616 12.011 3.616C12.011 3.616 4.50401 3.606 2.61501 4.117C2.11677 4.25605 1.66283 4.52128 1.29706 4.88705C0.931287 5.25282 0.666058 5.70676 0.527007 6.205C0.172528 8.11951 -0.0022322 10.063 0.00500725 12.01C-0.000863617 13.9497 0.173891 15.8857 0.527007 17.793C0.666058 18.2912 0.931287 18.7452 1.29706 19.1109C1.66283 19.4767 2.11677 19.7419 2.61501 19.881C4.48301 20.383 12.011 20.383 12.011 20.383C12.011 20.383 19.517 20.383 21.407 19.881C21.9052 19.7419 22.3592 19.4767 22.725 19.1109C23.0907 18.7452 23.356 18.2912 23.495 17.793C23.8407 15.885 24.0081 13.949 23.995 12.01C24.0095 10.0636 23.8421 8.1202 23.495 6.205V6.205ZM9.60901 15.601V8.408L15.873 12.01L9.60901 15.601Z"
        />
      </svg>
    )
  }
}
